import type { JSX } from 'react'

export const TvIcon = ({ filled }: { filled?: boolean }): JSX.Element => (
  <>
    <use href='#tvIcon' height='100%' width='100%' />
    <use
      href='#tvSolidIcon'
      height='100%'
      width='100%'
      fillOpacity={filled ? 1 : 0}
    />
  </>
)
